export default {
  basic: 'basic',
  pro: 'pro',
  ultimate: 'ultimate'
};
